import { isSpSize } from "../../common/utils/isSpSize";
import MathUtil from "../../common/utils/MathUtil";
import MarkerManager from "./MarkerManager";

class AbstractParticles extends PIXI.Container {
  // ---------------------------------------------------------------------------
  // --	AbstractParticles
  // ---------------------------------------------------------------------------

  constructor(markerSelector) {
    super();

    //変数
    this.baseRot = 0;
    this.baseRotSpeed = 0.5;
    this.scrollRot = 0;
    this.scrollOpRot = 0;
    this.srollRotSpeed = 10;

    //コンテナ
    this.container = new PIXI.Container();
    this.addChild(this.container);

    //マーカー読み込み
    this.manager = new MarkerManager(document.querySelectorAll(markerSelector));
  }

  // ---------------------------------------------------------------------------
  // --	UPDATE
  // ---------------------------------------------------------------------------

  update() {
    this.baseRot += this.baseRotSpeed;
    this.scrollRot += (this.scrollOpRot - this.scrollRot) / 3;
    this.container.rotation = MathUtil.degreeToRadian(
      this.baseRot + this.scrollRot
    );
  }

  // ---------------------------------------------------------------------------
  // --	Scroll
  // ---------------------------------------------------------------------------

  onScroll(scrollY) {
    this.scrollOpRot = scrollY / this.srollRotSpeed;
    const progress = this.manager.getProgress(scrollY);
    this.onProgress(progress);
  }

  onProgress(progress) {
    this.alpha = progress.alpha;
    this.scale.set(progress.scale, progress.scale);
  }

  // ---------------------------------------------------------------------------
}

export default AbstractParticles;
